class NavTabsToggle {
  constructor() {
    this.navTabsToggle = document.querySelector("[data-nav-tabs-toggle]");
    this.navTabs = document.querySelector("[data-nav-tabs]");
    this.navTabsNav = document.querySelector("[data-nav-tabs-nav]");
    this.closeText = document.querySelector(
      ".nav-tabs-toggle__close"
    ).innerHTML;
    this.openText = document.querySelector(".nav-tabs-toggle__open").innerHTML;

    this.isOpen = false;
  }

  init = () => {
    if (this.navTabsToggle && this.navTabs) {
      this.navTabsToggle.addEventListener("click", this.toggle);
    }
  };

  toggle = () => {
    (this.isOpen ? this.close : this.open)();
  };

  open = () => {
    this.isOpen = true;

    this.navTabsToggle.classList.add("is-active");
    this.navTabs.classList.add("is-open");

    this.navTabsToggle.setAttribute("aria-expanded", "true");
    this.navTabsToggle.setAttribute("aria-label", this.closeText);
  };

  close = () => {
    this.isOpen = false;

    this.navTabsToggle.classList.remove("is-active");
    this.navTabs.classList.remove("is-open");

    this.navTabsToggle.setAttribute("aria-expanded", "false");
    this.navTabsToggle.setAttribute("aria-label", this.openText);
  };

  closeOnEscape = (event) => {
    if (event.keyCode === 27) {
      this.close();
    }
  };
}

export default NavTabsToggle;
